require("./src/css/normalize.css");
require("./src/css/webflow.css");
require("./src/css/internship-blog.webflow.css");
require("./src/css/custom-styles.css");


const { registerLinkResolver } = require('gatsby-source-prismic-graphql');
const { linkResolver } = require('./src/utils/linkResolver');

registerLinkResolver(linkResolver);
